import type { Saga } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  receiveIsAccountPastDue,
  receiveIsAccountPastDueError,
  USER,
} from '../../services/actions/userActions';
import { getIsAccountPastDue } from '../../services/api/account';

const { REQUEST_ACCOUNT_PAST_DUE } = USER;

// WORKER SAGA
function* fetchIsAccountPastDue(): Saga<void> {
  try {
    const response = yield call(getIsAccountPastDue);
    yield put(receiveIsAccountPastDue(response && response.isAccountPastDue));
  } catch (error) {
    yield put(receiveIsAccountPastDueError(error));
  }
}

// WATCHER SAGAS
export default function* watchFetchUserData(): Saga<void> {
  yield takeEvery(REQUEST_ACCOUNT_PAST_DUE, fetchIsAccountPastDue);
}
